module.exports = __webpack_public_path__ + "static/media/bigwar-3.60930698.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bigwar-3.png
// module id = 99
// module chunks = 0